<template>
    <div class="col-sm-12 box-col-12">
        <div class="donut-chart-widget">
          <div class="card">
            <div class="card-header pb-0">
              <h3>Browser Uses</h3>
            </div>
            <div class="card-body">
              <div id="chart-widget13"> <apexchart height="515px" :options="browser.options" :series="browser.series"></apexchart></div>
             
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import wcharts from '../../../data/widgets/charts/wcharts'
export default{
    name:'browseruserPage',
    data(){
        return{
            browser:wcharts.BrowserUses
        }
    }
}
</script>